import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export default {
  init() {
    // JavaScript to be fired on the home page

     // Use gsap and ScrollTrigger
     gsap.registerPlugin(ScrollTrigger);
     let reveals = gsap.utils.toArray('.text-decoration--animate');
     reveals.forEach((reveal) => {
         ScrollTrigger.create({
             trigger: reveal,
             start: 'top 75%', // when the top of the element is 75% from the top of the viewport
             toggleClass: 'text-decoration--animated',
             // toggleActions: 'play pause resume none',
             once: true, // only trigger the toggle once. we can control repeat behavior using toggleActions
         });
     });

     setTimeout(() => {
       let $textUnderlines = $('.text-decoration--animate');
        $textUnderlines.each(function() {
          $(this).addClass('text-decoration--animate-complete');
        });

    }, 2750);

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js